
const Name = (cell) => {
    return cell.value ? cell.value : '';
};
const Name_en = (cell) => {
  return 'Office';
  // return cell.value ? cell.value : ""
};
const Name_fr = (cell) => {
    return '+961665533';
    // return cell.value ? cell.value : ""
};

const Name_ar = (cell) => {
  return 'Lebanon, North lebanon, Batroun';
  // return cell.value ? cell.value : ""
};

const IsActive = cell => {
  return cell.value ? cell.value : ""
}



export { Name_ar, Name_en, Name, Name_fr, IsActive }